import { render } from "./VPullRefresh.vue?vue&type=template&id=2619a5a2"
import script from "./VPullRefresh.vue?vue&type=script&lang=js"
export * from "./VPullRefresh.vue?vue&type=script&lang=js"

import "./VPullRefresh.vue?vue&type=style&index=0&id=2619a5a2&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__